import { toTitleCase } from 'common/utils';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomDialog from 'components/dialogs/CustomDialog'
import { useAuth } from 'context/AuthContext';
import { useProfileContext } from 'context/ProfileContext';
import { useDeleteExperience, useDeleteReimbursement } from 'hooks/useUsers';
import React, { useState } from 'react'
import { snackbarService } from 'services/snackbarService';

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default function DeleteReimbursementDialog({
  open,
  setOpen,
}: Props) {
  const { user } = useAuth();
  const { refetch } = useProfileContext();

  const { mutate: deleteMutation, isLoading } = useDeleteReimbursement(
    (data: any) => {
      setOpen(false);
      snackbarService.showSnackbar(`Reimbursement info has been deleted successfully`, 'success');
      refetch();
    },
    (error: any) => {
      console.log('error', error);
    },
  )

  const handleDelete = () => {
    deleteMutation(user.id);
  };

  return (
    <CustomDialog
      open={open}
      title={`Delete reimbursement`}
      message={`Are you sure you want to delete reimbursement info?`}
      buttons={[
        <CustomButton
          key='cancel'
          text='Cancel'
          variant='outlined'
          onClick={() => setOpen(false)}
          disabled={isLoading}
        />,
        <CustomButton
          key='delete'
          text='Delete'
          color='error'
          onClick={handleDelete}
          loading={isLoading}
        />
      ]}
    />
  )
}
